import { InsightsPage } from "../hooks/insights/insights";

/**
 *
 * @returns {ReactElement} Insights route
 */
export function Insights() {
  return <InsightsPage />;
}
